import React from 'react'
import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import {  AppStr } from 'cloak-file-sdk-web'

const linkStyle = {
	color : '#fff',
}

const linkStyle2 = {
	color : '#f3b90b',
}

class Footer extends React.PureComponent {

	render() {
		return (
			<div className="clk-footer-div">
				<div className="clk-footer">
					<div className="clk-footer-block">
						<div>
							<a href={AppStr.SITE_URL} target="_blank" rel="noopener noreferrer" style={linkStyle2}>
								<FormattedMessage id="cloak.about"/>&nbsp;
							</a>
						</div>
					</div>
					<div className="clk-footer-link-separator" />
					<div className="clk-footer-block">
						<div>
							<a href="mailto:support@cloakapps.com?Subject=Cloak%20Support" target="_blank" rel="noopener noreferrer" style={linkStyle}>
								&nbsp;<FormattedMessage id="cloak.support"/>&nbsp;
							</a>
						</div>
						<div className="clk-footer-link-separator" />
						<div>
							<a href={AppStr.SITE_URL + "/index.html#faq"} target="_blank" rel="noopener noreferrer" style={linkStyle}>
								&nbsp;<FormattedMessage id="cloak.faq"/>&nbsp;
							</a>
						</div>
					</div>
					<div className="clk-footer-link-separator" />
					<div className="clk-footer-block">
						<div>
							<a href={AppStr.SITE_URL + "/privacy.html"} target="_blank" rel="noopener noreferrer" style={linkStyle}>
								&nbsp;<FormattedMessage id="cloak.privacy"/>&nbsp;
							</a>
						</div>
						<div className="clk-footer-link-separator" />
						<div>
						 <a href={AppStr.SITE_URL + "/terms.html"} target="_blank" rel="noopener noreferrer" style={linkStyle}>
								&nbsp;<FormattedMessage id="cloak.srvcTrms"/>&nbsp;
						 </a>
						</div>
						<div className="clk-footer-link-separator" />
						<div>
							<NavLink to="/cloak/upgrade" style={linkStyle2}>
								&nbsp;<FormattedMessage id="upgrade.upgrade"/>
							</NavLink>
						</div>
					</div>
				</div>
			</div>
			)
	}
}

export default Footer
